module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 161
// module chunks = 0